<template>
    <div class="gap-3 mt-4"
        :class="[{ 'hidden keep': !canGoBack && !canGoForward, 'd-none d-md-flex': !showOnSm, 'd-flex': showOnSm }, marginClass]">

        <i class="bi bi-arrow-left rounded-circle nav-icon ripple"
            :class="{ 'disabled': !canGoBack, 'light': lightBtns }" @click="goBack"></i>

        <i class="bi bi-arrow-right rounded-circle nav-icon ripple"
            :class="{ 'disabled': !canGoForward, 'light': lightBtns }" @click="goForward"></i>

    </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { useRouter } from 'vue-router';

defineProps({
    lightBtns: Boolean,
    showOnSm: {
        type: Boolean,
        default: false
    },
    marginClass: {
        type: String,
        default: 'mb-large'
    }
})

const canGoBack = ref(false);
const canGoForward = ref(false);

const router = useRouter();

const goBack = () => {
    if (!canGoBack) return;
    router.back();
};

const goForward = () => {
    if (!canGoForward) return;
    router.forward();
};

const updateButtons = () => {
	console.log('history state : ' , history.state);
	console.log('history position : ' + history.state.position);
	console.log('history length : ' + history.length);
    canGoBack.value = history.state.position > 0;
    canGoForward.value = history.length > 1 && history.state.position < history.length - 1;
};

onMounted(() => {
    updateButtons();
    nextTick(() => {
        updateButtons();
    })
});

// check if router is changed
router.afterEach(() => {
	updateButtons();
});
</script>